import { format, isSameDay, subDays } from "date-fns";

export const createDateLabel = (date: Date) => {
  if (isSameDay(date, new Date())) {
    return "Today";
  } else if (isSameDay(date, subDays(new Date(), 1))) {
    return "Yesterday";
  } else {
    return formatDate(date);
  }
};

export const formatDate = (date: Date) => {
  return date.getFullYear() === new Date().getFullYear()
    ? format(date, "MMM do")
    : format(date, "PPP");
};
